/**
 * Enum representing the possible behaviors when a required parameter is missing
 * in a post-back configuration.
 */
export enum OnMissingBehavior {
  /**
   * Skip the parameter and continue with the post-back
   */
  Skip = 'Skip',

  /**
   * Retry the post-back operation after some delay
   */
  Retry = 'Retry',

  /**
   * Log the missing parameter but continue with the operation
   */
  Log = 'Log',
}
